import React from 'react'
import Service1 from '../../assets/images/resources/features-three-left-img-1.jpg'
import Service2 from '../../assets/images/resources/features-three-left-img-2.jpg'


function FeaturesThreeSix() {
  return (
    <div>
      <section className="features-three features-six">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12">
              <div className="features-three-left-box">
                <div className="features-three-left-box-shape-1" />
                <div className="features-three-left-box-shape-2" />
                <div className="features-three-left-box-shape-3" />
                <div className="features-three-left-box-shape-4" />
                <div
                  className="features-three-left-img-box wow fadeInLeft animated"
                  data-wow-duration="1500ms"
                  data-wow-delay="300ms"
                >
                  <div className="features-three-left-img-1">
                    <img
                      src={Service1}
                      alt="features-three-left-img-1"
                    />
                  </div>
                </div>
                <div
                  className="features-three-left-img-box wow fadeInLeft animated"
                  data-wow-duration="1500ms"
                  data-wow-delay="100ms"
                >
                  <div className="features-three-left-img-2">
                    <img
                      src={Service2}
                      alt="features-three-left-img-2"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="col-xl-6 col-lg-12 col-md-12 col-sm-12">
              <div className="features-three-right-box features-six-right-box">
                <div
                  className="section-two-title wow fadeInRight animated"
                  data-wow-duration="1500ms"
                  data-wow-delay="100ms"
                >
                  <div className="section-two-title-title">
                    <h2>Customer Success and Work For Future</h2>
                  </div>
                </div>
                <div
                  className="section-two-details wow fadeInRight animated"
                  data-wow-duration="1500ms"
                  data-wow-delay="300ms"
                >
                  <p>
                    Sed ut perspiciatis unde omnis natus error voluptatem
                    accusantium doloremque laudantium, totam rem aperiam
                    inventore
                  </p>
                </div>
                <div className="features-three-right-info-box">
                  <div
                    className="features-three-right-info wow fadeInRight animated"
                    data-wow-duration="1500ms"
                    data-wow-delay="500ms"
                  >
                    <div className="features-three-right-info-title">
                      <i className="icon-check" />
                      <h4>Concepts &amp; Scripting</h4>
                    </div>
                    <div className="features-three-right-info-detail">
                      <p>
                        It takes ages to generate ideas, research them
                        create compelling scripts. Not anymore is an idea
                        generation machine
                      </p>
                    </div>
                  </div>
                  <div
                    className="features-three-right-info wow fadeInRight animated"
                    data-wow-duration="1500ms"
                    data-wow-delay="700ms"
                  >
                    <div className="features-three-right-info-title">
                      <i className="icon-check" />
                      <h4>Strategy &amp; Producing</h4>
                    </div>
                    <div className="features-three-right-info-detail">
                      <p>
                        So many niches to choose from, so little time. How
                        do you stand Only 2.5% of YouTubers ever hit 1,000
                        subscribers.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default FeaturesThreeSix
